import PropTypes from 'prop-types';
import classNames from 'classnames';
import {useTranslation} from 'react-i18next';

const Loader = ({className, additionalMarkup}) => {
    const {t} = useTranslation();
    const classes = classNames('Loader', className);

    return (
        <div className={classes}>
            <div className="Loader-spinner">
                <h1>{t('loading')}...</h1>
            </div>
            {additionalMarkup}
        </div>
    );
};

Loader.propTypes = {
    /** Additional class(es) to add to the component. */
    className: PropTypes.string,
    /** Additional markup to place below the loading spinner. */
    additionalMarkup: PropTypes.node,
};

export default Loader;
